import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../constants/breakpoints';

const useIsMobile = (threshold = MOBILE_BREAKPOINT) => {
  const checkMobile = () => window.innerWidth <= threshold;
  const [isMobile, setIsMobile] = useState(checkMobile());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkMobile());
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [threshold]);

  return isMobile;
};


export default useIsMobile;
